<atx-svg-viewer [svg]="svgContent"></atx-svg-viewer>
